const METRIC_WIDGETS = [
  { id: 'metrics1', name: 'Incident Time', icon: '🕐', category: 'Metrics' },
  { id: 'metrics3', name: 'Last Update', icon: '🔄', category: 'Metrics' },
  { id: 'metrics4', name: 'Duration', icon: '⏱️', category: 'Metrics' },
];

const CORE_WIDGETS = (incident) => [
  { id: 'locationMap', name: 'Location Map', icon: '📍', category: 'Core' },
  { id: 'teamsCrews', name: incident?.is_exercise ? 'Drill Participants' : 'Incident Participants', icon: '👥', category: 'Core' },
  { id: 'departments', name: 'Organization & Departments', icon: '🏢', category: 'Core' },
  { id: 'attachments', name: 'Attachments', icon: '📎', category: 'Core' },
];

/**
 * Keep widget availability aligned with the workspace the operator is using.
 * Scenario templates deliberately omit live timing and the standalone chat
 * card. Weather Status and Additional Map were placeholder-only widgets and
 * are no longer offered in any incident, drill, or scenario workspace.
 */
export const buildIncidentDetailWidgetCatalog = ({
  incident,
  scenarioEnv = false,
  scenarioMode = false,
} = {}) => [
  ...(!scenarioEnv ? METRIC_WIDGETS : []),
  ...CORE_WIDGETS(incident),
  ...(!scenarioEnv ? [{ id: 'chat', name: 'Team Chat', icon: '💬', category: 'Additional' }] : []),
  ...(!incident?.is_exercise ? [
    ...(incident?.matched_scenario_id ? [{
      id: 'exerciseTimeline',
      name: 'Response Plan Timeline (Injection Sequence)',
      icon: '⚡',
      category: 'Response Plan',
    }] : []),
    { id: 'availableResources', name: 'Resources', icon: '📦', category: 'Scenario' },
    { id: 'auditLog', name: 'Audit Log', icon: '📜', category: 'Scenario' },
    { id: 'correctiveActions', name: 'Corrective Actions & Review', icon: '🛠️', category: 'Scenario' },
  ] : []),
  ...(incident?.is_exercise ? [
    { id: 'simulationObjective', name: 'Drill Objective', icon: '🎯', category: 'Exercise' },
    { id: 'discussionGroup', name: (scenarioEnv || scenarioMode) ? 'Scenario Discussion Group' : 'Plan Discussion Group', icon: '🗣️', category: 'Exercise' },
    { id: 'exerciseTimeline', name: 'Exercise Timeline (Injection Sequence)', icon: '⚡', category: 'Exercise' },
    { id: 'availableResources', name: 'Resources', icon: '📦', category: 'Exercise' },
    { id: 'assignedRoles', name: 'Assigned Roles', icon: '🧑‍🚒', category: 'Exercise' },
    { id: 'auditLog', name: 'Audit Log', icon: '📜', category: 'Exercise' },
    { id: 'correctiveActions', name: 'Corrective Actions & AAR', icon: '🛠️', category: 'Exercise' },
  ] : []),
];
